import React from "react";

const ErrorMessage = ({message}) => {
  return (
    <div className="row" style={{ padding: "50px" }}>
      <div className="col-sm-12 text-center">
        <div style={{ fontSize: "25px" }}>🙊</div>{message}
      </div>
    </div>
  );
}

export default ErrorMessage;
